import { yupResolver } from "@hookform/resolvers/yup";
import CommentController from "components/ReuseableCompos/CommentsForm/CommentController";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import MolhamInput from "components/ReuseableCompos/MolhamInput";
import useUpdateEffect from "customHooks/useUpdateEffect";
import useTranslation from "next-translate/useTranslation";
import { useForm } from "react-hook-form";
import * as Yup from "yup";

type Props = {
  onSubmit: (data: any) => void;
  content?: string;
  subject?: string;
  close?: () => void;
  textLength?: number;
};

export default function FeedbackForm({
  close,
  content,
  onSubmit,
  textLength,
  subject,
}: Props) {
  const { t } = useTranslation("common");

  const validationSchema = Yup.object().shape({
    content: Yup.string()
      .min(10, t(`comment_min_invalid`))
      .max(textLength || 250, t(`comment_max_invalid`))
      .required(t(`field_required`)),
  });
  const { handleSubmit, reset, setValue, control, register, watch } = useForm<{
    content: string;
    subject: string;
  }>({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  useUpdateEffect(() => {
    if (content) setValue("content", content, { shouldValidate: true });
    if (subject) setValue("subject", subject, { shouldValidate: true });
  }, [content, subject]);

  const onFormSubmit = async (data) => {
    onSubmit(data);
    reset();
    close ? close() : null;
  };
  return (
    <form
      className="needs-validation"
      noValidate
      onSubmit={handleSubmit(onFormSubmit)}
    >
      <div className="">
        <MolhamInput
          control={control}
          name={"subject"}
          placeholder={t("subject") + "..."}
          watch={watch}
          label={t("subject")}
        />

        <label className="form-label fs-md px-0  mt-3">
          {t("message_label")}
        </label>
        <CommentController
          control={control}
          watch={watch}
          name="content"
          textLength={textLength}
          placeholder={t("message_label") + "..."}
        />
      </div>

      <MolhamButton
        id="support-issue-submit-btn"
        label={t("send")}
        className="w-100"
      />
    </form>
  );
}
